import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore, DashboardUserType } from '@store';
import { filter, map } from 'rxjs/operators';
import { DashboardInstallationUrls } from './installations-routing.helper';
import { UIService } from '../shared/services';

export const kanbanBoardGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const uiService = inject(UIService);

  return authStore.dashboardUserType$.pipe(
    filter((val) => val !== undefined),
    map((dashboardUserType) => {
      if (dashboardUserType === DashboardUserType.Maintainer && !uiService.isMobileView()) {
        return true;
      } else {
        // cancel navigation
        router.navigate([DashboardInstallationUrls.List]);

        return false;
      }
    })
  );
};
